import Multiselect from 'vue-multiselect'

export default {
    extends: Multiselect,
    mounted () { this.syncAccessibility() },
    updated () { this.syncAccessibility() },
    beforeDestroy () {
        const input = this.$refs.search
        if (input && document.activeElement === input) input.blur()
    },
    methods: {
        syncAccessibility () {
            const control = this.$refs.search || this.$el
            const id = 'tone-options-' + this._uid
            const list = this.$el.querySelector('.multiselect__content')
            if (!list) return
            control.setAttribute('role', 'combobox')
            control.setAttribute('aria-label', this.$attrs['aria-label'] || this.placeholder || 'Select recipients')
            control.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false')
            control.setAttribute('aria-haspopup', 'listbox')
            control.setAttribute('aria-controls', id)
            if (this.searchable) control.setAttribute('aria-autocomplete', 'list')
            list.id = id
            list.setAttribute('role', 'listbox')
            list.setAttribute('aria-multiselectable', this.multiple ? 'true' : 'false')
            const options = this.$el.querySelectorAll('.multiselect__element')
            Array.prototype.forEach.call(options, (option, index) => {
                option.id = id + '-' + index
                option.setAttribute('role', 'option')
                const value = this.filteredOptions[index]
                option.setAttribute('aria-selected', this.isSelected(value) ? 'true' : 'false')
                option.setAttribute('aria-disabled', value && value.$isDisabled ? 'true' : 'false')
            })
            if (this.isOpen && options[this.pointer]) control.setAttribute('aria-activedescendant', options[this.pointer].id)
            else control.removeAttribute('aria-activedescendant')
            Array.prototype.forEach.call(this.$el.querySelectorAll('.multiselect__tag-icon'), (remove, index) => {
                const value = this.visibleValues[index]
                remove.removeAttribute('aria-hidden')
                remove.setAttribute('role', 'button')
                remove.setAttribute('tabindex', this.disabled ? '-1' : '0')
                remove.setAttribute('aria-label', 'Remove ' + this.getOptionLabel(value))
                remove.onkeydown = event => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault()
                        event.stopPropagation()
                        if (!event.repeat && !this.disabled) {
                            this.removeElement(value)
                            this.$nextTick(() => {
                                if (!this._isDestroyed && !this._isBeingDestroyed) control.focus()
                            })
                        }
                    }
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/accessibility/Multiselect.js